export default [{
    path: "/recruit",
    name: "recruit",
    meta: {
      title: "活动专场"
    },
    component: () => import("./recruit.vue")
  },
  {
    path: "/recruit/detail/:id",
    name: "recruitDetail",
    meta: {
      title: "活动专场详情",
      requireAuth: true
    },
    component: () => import("./detail.vue")
  },
  {
    path: "/recruit/activities/nov",
    name: "recruitActivities",
    meta: {
      title: "猎上双十一，狂欢嗨到底！"
    },
    component: () => import("./activities/nov.vue")
  },
  {
    path: "/recruit/activities/dec",
    name: "recruitActivitiesDec",
    meta: {
      title: "猎上双旦嘉年华 - 百万现金红包抽不停，天天都有现金领！"
    },
    component: () => import("./activities/dec.vue")
  }
];